import { ButtonBase } from "@mui/material";

import { CaretRightIcon } from "@/components/Icons/rtlReadyIcons";
import { FlightRouteAndDate } from "@/features/flights/components/flight-purchase/FlightRouteAndDate";
import type { GetFlightAvailabilityTokenFlightV2 } from "@/types/codegen";

type Props = {
  flightDetails: GetFlightAvailabilityTokenFlightV2;
  segmentDirection?: "departure" | "return";
  onClick: () => void;
};

export const FlightButton = ({
  flightDetails,
  segmentDirection,
  onClick,
}: Props) => {
  return (
    <ButtonBase
      sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}
      onClick={onClick}
    >
      <FlightRouteAndDate
        flightDetails={flightDetails}
        segmentDirection={segmentDirection}
      />
      <CaretRightIcon size={16} color="var(--color-stone)" weight="bold" />
    </ButtonBase>
  );
};
